import axios from 'axios';
import React,{ useState,useEffect,useRef } from 'react';

function GroupChatCard(props) {    
    const [messages, setMessages] = useState([])
    const [forUseEffect, setForUseEffect] = useState(false);
    const [date, setDate] = useState("");
    const [lastMessage, setLastMessage] = useState("");
    const [sender, setSender] = useState("");
    const chatCard = useRef();

  useEffect(() => {
    axios.post("https://newchatapp-mn65.onrender.com/groupmessages",{_id:props.id}).then((res) => {
        var n=0;
        res.data.forEach( message=>{   
            props.setCurrMessages((prev)=>{
                if(n==0){
                    setDate(message.date);
                    setLastMessage(message.body);
                    if(message.sender!==props.me) setSender(message.sender);
                    n=n+1;
                   }
            })
        })
    })
  }, [])
  
    
useEffect(() => {
    if(forUseEffect){
       
        props.socket.emit("join_room",props.roomId);
        localStorage.setItem("roomId", props.roomId);
        if(messages.length!==0){
            var n=0;
            messages.forEach( message=>{ 
                if(n==0){
                    setDate(message.date);
                    setLastMessage(message.body)
                    if(message.sender!==props.me) setSender(message.sender);
                    n=n+1;
                }
                props.setCurrMessages((prev)=>{
                    return(
                        [...prev,message ]
                    )
                })
            })
        }
        props.setRightDisplay({
        image:props.image,
        firstname:props.firstname,
        room:props.roomId,
        showRight:true,
        groupId:props.id,
     })
     const input = document.querySelector(".chatTypeInput");
     if(input!==null) input.focus();
    }else{
        setForUseEffect(true);
    }
    
}, [messages])           
                      
   

function handleClick(e){
   
    var lc = localStorage.getItem("roomId");
    if(lc){
        props.socket.emit('forceDisconnect',lc);
    }

    props.setCurrMessages([]);

    axios.post("https://newchatapp-mn65.onrender.com/groupmessages",{_id:props.id}).then((res) => {
        setMessages(res.data);
    })
     
    document.querySelectorAll(".check").forEach(data=>{
        data.classList.remove("selectedUser");
    })

    chatCard.current.classList.add("selectedUser");
    }

    return (
        <div  className="chatcard ">
        <div ref={chatCard} onClick={handleClick} className="check"></div>
            <div onClick={handleClick} className="userchatcard">
                <img draggable="false" className='chatprofile homeprofilepic' src={props.image} alt="ChatCard" />
                <div className="userchatcardinfo">
                    <h3>{props.firstname}</h3>
                    <p>{!props.lstMessage && (sender===""?null:sender+" : ")}  {(props.lstMessage&&(props.lstMessage.length>20?(props.lstMessage.substr(0,19)+"..."):props.lstMessage)) || (lastMessage && (lastMessage.length>20?(lastMessage.substr(0,19)+"..."):lastMessage)) }</p>
                </div>
                <small>{date}</small>
            </div>
            <hr className='hrcard' />
        </div>

    )
}

export default GroupChatCard